import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.563 10.188a4.53 4.53 0 0 1 4.531-4.53h1.813a4.53 4.53 0 0 1 4.531 4.53v2.797a2 2 0 0 0 .586 1.414l.641.641a2 2 0 0 1 .586 1.414 1.89 1.89 0 0 1-1.89 1.89H6.64a1.89 1.89 0 0 1-1.89-1.89 2 2 0 0 1 .586-1.414l.641-.64a2 2 0 0 0 .586-1.415z",
      stroke: "black",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.707 18.344v.365a2.29 2.29 0 0 0 2.292 2.29v0a2.29 2.29 0 0 0 2.292-2.291v-.365",
      stroke: "black",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.834 5.751v-.918c0-1.012-.82-1.833-1.833-1.833v0a1.833 1.833 0 0 0-1.833 1.833v.918",
      stroke: "black",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }